<div class="container-fluid glb-popup" style="max-width: 600px;">
  <h2>{{ formTitle }}</h2>
  <p-toast [style]="{ marginTop: '80px' }"> </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float: right; top: -50px; background-color: transparent">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr />
  <div [formGroup]="form1" class="forms w-100 d-block">
    <div class="row m-0">
      <div class="col-lg-12">
        @if (formAlert) {
          <div class="w-100 mb-3">
					<div class="w-100" style="
              text-align: center;
              background-color: yellow;
              padding: 5px;
              margin-bottom: 15px;
            ">
              <p>
                <b>{{ formAlert }}</b>
              </p>
            </div>
          </div>
        }
      </div>

      <div class="col-11 row py-0">
        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-4">
            @if (propertyProfiles?.length > 0) {
              <p-dropdown [options]="propertyProfiles"
                formControlName="propertyProfileId" optionLabel="propertyName"
                optionValue="propertyProfileId" [filter]="true" filterBy="propertyName" [showClear]="false"
                placeholder="Select Property Profile" appendTo="body">
              </p-dropdown>
            }
            <label for="propertyProfileId">Select Property Profile</label>
            @for (validation of validationMessages.propertyProfileId; track validation) {
              <span>
                @if (form1.get('propertyProfileId').hasError(validation.type) && (form1.get('propertyProfileId').dirty || form1.get('propertyProfileId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-1 py-0 d-flex justify-content-end align-items-center">
          <button class="btn btn-icon btn-success rounded-pill mb-4" (click)="formAddPropertyProfile()">
            <i class="pi pi-plus"></i>
          </button>
        </div>
        @if (form1.controls['propertyProfileId'].value) {
          <div
            class="col-1 py-0 d-flex justify-content-end align-items-center">
            <button class="btn btn-icon mb-4">
              <i class="pi pi-pencil" aria-hidden="true" (click)="formEditPropertyProfiles()"
              style="color:blue;"></i>
            </button>
          </div>
        }
      </div>

      <div class="col-11 row py-0">
        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-4">
            @if (realtorProperties?.length > 0) {
              <p-dropdown [options]="realtorProperties"
                formControlName="realtorProfileId" optionLabel="displayLabel" optionValue="realtorProfileId"
                [filter]="true" filterBy="displayLabel" [showClear]="false" placeholder="Select Realtor"
                appendTo="body">
              </p-dropdown>
            }
            <label for="Select Realtor">Realtor Profile 1</label>
            @for (validation of validationMessages.realtorProfileId; track validation) {
              <span>
                @if (form1.get('realtorProfileId').hasError(validation.type) && (form1.get('realtorProfileId').dirty || form1.get('realtorProfileId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-1 py-0 d-flex justify-content-end align-items-center">
          <button class="btn btn-icon btn-success rounded-pill mb-4" (click)="formAddRealtorProfile()">
            <i class="pi pi-plus"></i>
          </button>
        </div>
        @if (form1.controls['realtorProfileId'].value) {
          <div
            class="col-1 py-0 d-flex justify-content-end align-items-center">
            <button class="btn btn-icon mb-4">
              <i class="pi pi-pencil" aria-hidden="true" (click)="formEditRealtorProfile(realtorProfile)"
              style="color:blue;"></i>
            </button>
          </div>
        }
      </div>

      <div class="col-11 row py-0">
        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-4">
            @if (realtorProperties?.length > 0) {
              <p-dropdown [options]="realtorProperties"
                formControlName="realtorProfileId2" optionLabel="displayLabel" optionValue="realtorProfileId"
                [filter]="true" filterBy="displayLabel" [showClear]="false" placeholder="Select Realtor"
                appendTo="body">
              </p-dropdown>
            }
            <label for="Select Realtor">Realtor Profile 2</label>
            @for (validation of validationMessages.realtorProfileId; track validation) {
              <span>
                @if (form1.get('realtorProfileId').hasError(validation.type) && (form1.get('realtorProfileId').dirty || form1.get('realtorProfileId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-1 py-0 d-flex justify-content-end align-items-center">
          <button class="btn btn-icon btn-success rounded-pill mb-4" (click)="formAddRealtorProfile()">
            <i class="pi pi-plus"></i>
          </button>
        </div>
        @if (form1.controls['realtorProfileId'].value) {
          <div
            class="col-1 py-0 d-flex justify-content-end align-items-center">
            <button class="btn btn-icon mb-4">
              <i class="pi pi-pencil" aria-hidden="true" (click)="formEditRealtorProfile(realtorProfile2)"
              style="color:blue;"></i>
            </button>
          </div>
        }
      </div>

      <div class="col-12 row py-0">
        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-4">
            <p-autoComplete class="col-lg-12" [suggestions]="taskUserSuggestions" [multiple]="false"
              [forceSelection]="true" [dropdown]="false"
              [style]="{'width':'100%','padding-bottom':'20px'}" [inputStyle]="{'width':'100%'}"
              [minLength]="1" unique="true" field="summary" (completeMethod)="onKeyInput($event)"
            formControlName="agnt1"> </p-autoComplete>
            <label for="agnt1">Agent 1 (Enter name to get agent1 options)</label>
            @if (isAgent1) {
              <small class="p-invalid">Agent 1 not found (If you are not able to find name of agent, Please create new employee profile of click right side + button)</small>
            }
            @for (validation of validationMessages.agnt1; track validation) {
              <span>
                @if (!isAgent1 && form1.get('agnt1').hasError(validation.type) && (form1.get('agnt1').dirty || form1.get('agnt1').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-1 py-0 d-flex justify-content-end align-items-center">
          <button class="btn btn-icon btn-success rounded-pill mb-4" (click)="createEmployeeProfile()">
            <i class="pi pi-plus"></i>
          </button>
        </div>
      </div>
      <div class="col-12 row py-0">
        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-4">
            <p-autoComplete class="col-lg-12" [suggestions]="taskUserSuggestions" [multiple]="false"
              [forceSelection]="true" [dropdown]="false"
              [style]="{'width':'100%','padding-bottom':'20px'}" [inputStyle]="{'width':'100%'}"
              [minLength]="1" unique="true" field="summary" (completeMethod)="onKeyInput1($event)"
            formControlName="agnt2"> </p-autoComplete>
            <label for="agnt2">Agent 2 (Enter name to get agent2 options)</label>
            <span>
              @if (isAgent2) {
                <small>Agent 2 not found (If you are not able to find name of agent, Please create new employee profile of click right side + button)</small>
              }
            </span>
            @for (validation of validationMessages.agnt2; track validation) {
              <span>
                @if (!isAgent2 && form1.get('agnt2').hasError(validation.type) && (form1.get('agnt2').dirty || form1.get('agnt2').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-1 py-0 d-flex justify-content-end align-items-center">
          <button class="btn btn-icon btn-success rounded-pill mb-4" (click)="createEmployeeProfile()">
            <i class="pi pi-plus"></i>
          </button>
        </div>

        <div class="col-8"></div>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <p-inputNumber class="w-100 eap-input" formControlName="estGrossRev" (keyup)="updateAmount($event, 'estgrossrev')" id="estGrossRev" inputId="currency-us" mode="currency" currency="USD" locale="en-US">
          </p-inputNumber>
          <label for="estGrossRev">Estimated Gross Revenue</label>
          @for (validation of validationMessages.estGrossRev; track validation) {
            <span>
              @if (
                form1.get('estGrossRev').hasError(validation.type) &&
                (form1.get('estGrossRev').dirty ||
                form1.get('estGrossRev').touched)
                ) {
                <small
                  class="p-invalid"
                  >{{ validation.message }}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-12">
        <span class="d-flex justify-content-start">
          <label>Mgmt Comm Pct : </label>&nbsp;
          <label>{{ (propertyProfile?.mgmtCommPct * 100) | number:'1.0-0' }} %</label>
        </span>
      </div>

      <div class="col-12">
        <span class="d-flex justify-content-start">
          <label>Contract Sign Date : </label>&nbsp;
          <label>{{propertyProfile?.contractSignDate | date}} </label>
        </span>
      </div>

      <div class="col-12">
        <span class="d-flex justify-content-start">
          <label>First CheckIn Date : </label>&nbsp;
          <label>{{propertyProfile?.firstCheckInDate | date}} </label>
        </span>
      </div>




      <div class="col-lg-6"></div>

      <div class="col-lg-12 mt-3"><b>Sales Agent 1</b></div>
      <div class="col-lg-4">
        <span class="p-float-label required-field w-100 mb-3">
          <p-dropdown [options]="percentageValuesPositive" formControlName="compAcqAgent1Pct" (onChange)="updateAmount($event, 'acqagent1pct')"
            optionLabel="name" optionValue="value" [filter]="true" filterBy="name" [showClear]="false"
            placeholder="Agent 1 Pct" appendTo="body">
          </p-dropdown>
          <label for="compAcqAgent1Pct">Agent 1 Pct</label>
          @for (validation of validationMessages.compAcqAgent1Pct; track validation) {
            <span>
              @if (form1.get('compAcqAgent1Pct').hasError(validation.type) && (form1.get('compAcqAgent1Pct').dirty || form1.get('compAcqAgent1Pct').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-4">
        <span class="p-float-label required-field w-100 mb-3">
          <p-dropdown [options]="percentageValuesPositive" formControlName="compAcqAgent1SplitPct" (onChange)="updateAmount($event, 'acqagent1splitpct')"
            optionLabel="name" optionValue="value" [filter]="true" filterBy="name" [showClear]="false"
            placeholder="Agent 1 Split Pct" appendTo="body">
          </p-dropdown>
          <label for="compAcqAgent1SplitPct">Agent 1 Split Pct</label>
          @for (validation of validationMessages.compAcqAgent1SplitPct; track validation) {
            <span>
              @if (form1.get('compAcqAgent1SplitPct').hasError(validation.type) && (form1.get('compAcqAgent1SplitPct').dirty || form1.get('compAcqAgent1SplitPct').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>


      <div class="col-lg-4">
        <span class="p-float-label required-field w-100 mb-3">
          <p-inputNumber class="w-100 eap-input" formControlName="compAcqAgent1Amt" id="compAcqAgent1Amt"
            inputId="currency-us" mode="currency" currency="USD" locale="en-US" readonly="true">
          </p-inputNumber>
          <label for="compAcqAgent1Amt">Agent 1 Amt</label>
          @for (validation of validationMessages.compAcqAgent1Amt; track validation) {
            <span>
              @if (
                form1.get('compAcqAgent1Amt').hasError(validation.type) &&
                (form1.get('compAcqAgent1Amt').dirty ||
                form1.get('compAcqAgent1Amt').touched)
                ) {
                <small class="p-invalid">{{ validation.message }}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-12">
        <span class="p-float-label required-field w-100 mb-3">
          <textarea formControlName="compAcqAgent1Desc" id="compAcqAgent1Desc" [rows]="2"
          pInputTextarea></textarea>
          <label for="compAcqAgent1Desc">Agent 1 Desc</label>
          @for (validation of validationMessages.compAcqAgent1Desc; track validation) {
            <span>
              @if (
                form1.get('compAcqAgent1Desc').hasError(validation.type) &&
                (form1.get('compAcqAgent1Desc').dirty ||
                form1.get('compAcqAgent1Desc').touched)
                ) {
                <small class="p-invalid">{{ validation.message }}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-12 mt-3"><b>Sales Agent 2</b></div>
      <div class="col-lg-4">
        <span class="p-float-label required-field w-100 mb-3">
          <p-dropdown [options]="percentageValuesPositive" formControlName="compAcqAgent2Pct" (onChange)="updateAmount($event, 'acqagent2pct')"
            optionLabel="name" optionValue="value" [filter]="true" filterBy="name" [showClear]="false"
            placeholder="Agent 2 Pct" appendTo="body">
          </p-dropdown>
          <label for="compAcqAgent2Pct">Agent 2 Pct</label>
          @for (validation of validationMessages.compAcqAgent2Pct; track validation) {
            <span>
              @if (form1.get('compAcqAgent2Pct').hasError(validation.type) && (form1.get('compAcqAgent2Pct').dirty || form1.get('compAcqAgent2Pct').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-4">
        <span class="p-float-label required-field w-100 mb-3">
          <p-dropdown [options]="percentageValuesPositive" formControlName="compAcqAgent2SplitPct" (onChange)="updateAmount($event, 'acqagent2splitpct')"
            optionLabel="name" optionValue="value" [filter]="true" filterBy="name" [showClear]="false"
            placeholder="Agent 2 Split Pct" appendTo="body">
          </p-dropdown>
          <label for="compAcqAgent2SplitPct">Agent 2 Split Pct</label>
          @for (validation of validationMessages.compAcqAgent2SplitPct; track validation) {
            <span>
              @if (form1.get('compAcqAgent2SplitPct').hasError(validation.type) && (form1.get('compAcqAgent2SplitPct').dirty || form1.get('compAcqAgent2SplitPct').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-4">
        <span class="p-float-label required-field w-100 mb-3">
          <p-inputNumber class="w-100 eap-input" formControlName="compAcqAgent2Amt" id="compAcqAgent2Amt"
            inputId="currency-us" mode="currency" currency="USD" locale="en-US" readonly="true">
          </p-inputNumber>
          <label for="compAcqAgent2Amt">Agent 2 Amt</label>
          @for (validation of validationMessages.compAcqAgent2Amt; track validation) {
            <span>
              @if (
                form1.get('compAcqAgent2Amt').hasError(validation.type) &&
                (form1.get('compAcqAgent2Amt').dirty ||
                form1.get('compAcqAgent2Amt').touched)
                ) {
                <small class="p-invalid">{{ validation.message }}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-12">
        <span class="p-float-label required-field w-100 mb-3">
          <textarea formControlName="compAcqAgent2Desc" id="compAcqAgent2Desc" [rows]="2"
          pInputTextarea></textarea>
          <label for="compAcqAgent2Desc">Agent 2 Desc</label>
          @for (validation of validationMessages.compAcqAgent2Desc; track validation) {
            <span>
              @if (
                form1.get('compAcqAgent2Desc').hasError(validation.type) &&
                (form1.get('compAcqAgent2Desc').dirty ||
                form1.get('compAcqAgent2Desc').touched)
                ) {
                <small class="p-invalid">{{ validation.message }}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-12 mt-3"><b>Payment 1 (At Close)</b></div>
      <div class="col-lg-3">
        <span class="p-float-label w-100 mb-3">
          <p-calendar formControlName="compAcqAgent1PayDate1" inputId="compAcqAgent1PayDate1" appendTo="body">
          </p-calendar>
          <label for="compAcqAgent1PayDate1">Agent1 Pay Date1</label>
          @for (validation of validationMessages.compAcqAgent1PayDate1; track validation) {
            <span>
              @if (
                form1.get('compAcqAgent1PayDate1').hasError(validation.type) &&
                (form1.get('compAcqAgent1PayDate1').dirty ||
                form1.get('compAcqAgent1PayDate1').touched)
                ) {
                <small class="p-invalid">{{ validation.message }}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-3">
        <span class="p-float-label required-field w-100 mb-3">
          <p-inputNumber class="w-100 eap-input" formControlName="compAcqAgent1PayDate1Amount" id="compAcqAgent1PayDate1Amount"
            inputId="currency-us" mode="currency" currency="USD" locale="en-US">
          </p-inputNumber>
          <label for="compAcqAgent1PayDate1Amount">Agent1 Pay Amt</label>
          @for (validation of validationMessages.compAcqAgent1PayDate1Amount; track validation) {
            <span>
              @if (
                form1.get('compAcqAgent1PayDate1Amount').hasError(validation.type) &&
                (form1.get('compAcqAgent1PayDate1Amount').dirty ||
                form1.get('compAcqAgent1PayDate1Amount').touched)
                ) {
                <small class="p-invalid">{{ validation.message }}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-3">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown class="w-100" [options]="statuses" formControlName="compAcqAgent1PayDate1Status"
          optionLabel="name" optionValue="value" placeholder="Payment Status"></p-dropdown>
          <label for="compAcqAgent1PayDate1Status">Payment Status</label>
          @for (validation of validationMessages.compAcqAgent1PayDate1Status; track validation) {
            <span>
              @if (
                form1.get('compAcqAgent1PayDate1Status').hasError(validation.type) &&
                (form1.get('compAcqAgent1PayDate1Status').dirty ||
                form1.get('compAcqAgent1PayDate1Status').touched)
                ) {
                <small class="p-invalid">{{ validation.message }}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-3">
        <span class="p-float-label required-field w-100 mb-3">
          <p-inputNumber class="w-100 eap-input" formControlName="actGrossRevYr1" id="actGrossRevYr1"
            inputId="currency-us" mode="currency" padControl="false" currency="USD" locale="en-US">
          </p-inputNumber>
          <label for="actGrossRevYr1">Act Gross Rev Yr 1</label>
          @for (validation of validationMessages.actGrossRevYr1; track validation) {
            <span>
              @if (
                form1.get('actGrossRevYr1').hasError(validation.type) &&
                (form1.get('actGrossRevYr1').dirty ||
                form1.get('actGrossRevYr1').touched)
                ) {
                <small class="p-invalid">{{ validation.message }}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-4">
        <span class="p-float-label w-100 mb-3">
          <p-calendar formControlName="compAcqAgent1PayDate2" inputId="compAcqAgent1PayDate2" appendTo="body">
          </p-calendar>
          <label for="compAcqAgent1PayDate2">Acq Agent1 Pay Date2</label>
          @for (validation of validationMessages.compAcqAgent1PayDate2; track validation) {
            <span>
              @if (
                form1.get('compAcqAgent1PayDate2').hasError(validation.type) &&
                (form1.get('compAcqAgent1PayDate2').dirty ||
                form1.get('compAcqAgent1PayDate2').touched)
                ) {
                <small class="p-invalid">{{ validation.message }}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-4">
        <span class="p-float-label required-field w-100 mb-3">
          <p-inputNumber class="w-100 eap-input" formControlName="compAcqAgent1PayDate2Amount" id="compAcqAgent1PayDate2Amount"
            inputId="currency-us" mode="currency" currency="USD" locale="en-US">
          </p-inputNumber>
          <label for="compAcqAgent1PayDate2Amount">Acq Agent1 Pay Date2 Amt</label>
          @for (validation of validationMessages.compAcqAgent1PayDate2Amount; track validation) {
            <span>
              @if (
                form1.get('compAcqAgent1PayDate2Amount').hasError(validation.type) &&
                (form1.get('compAcqAgent1PayDate2Amount').dirty ||
                form1.get('compAcqAgent1PayDate2Amount').touched)
                ) {
                <small class="p-invalid">{{ validation.message }}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-4">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown class="w-100" [options]="statuses" formControlName="compAcqAgent1PayDate2Status"
          optionLabel="name" optionValue="value" placeholder="Payment Status"></p-dropdown>
          <label for="compAcqAgent1PayDate2Status">Payment Status</label>
          @for (validation of validationMessages.compAcqAgent1PayDate2Status; track validation) {
            <span>
              @if (
                form1.get('compAcqAgent1PayDate2Status').hasError(validation.type) &&
                (form1.get('compAcqAgent1PayDate2Status').dirty ||
                form1.get('compAcqAgent1PayDate2Status').touched)
                ) {
                <small class="p-invalid">{{ validation.message }}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-12 mt-3"><b>Payment 2 (1 Year Anniversary)</b></div>
      <div class="col-lg-4">
        <span class="p-float-label w-100 mb-3">
          <p-calendar formControlName="compAcqAgent2PayDate1" inputId="compAcqAgent2PayDate1" appendTo="body">
          </p-calendar>
          <label for="compAcqAgent2PayDate1">Acq Agent2 Pay Date1</label>
          @for (validation of validationMessages.compAcqAgent2PayDate1; track validation) {
            <span>
              @if (
                form1.get('compAcqAgent2PayDate1').hasError(validation.type) &&
                (form1.get('compAcqAgent2PayDate1').dirty ||
                form1.get('compAcqAgent2PayDate1').touched)
                ) {
                <small class="p-invalid">{{ validation.message }}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-4">
        <span class="p-float-label required-field w-100 mb-3">
          <p-inputNumber class="w-100 eap-input" formControlName="compAcqAgent2PayDate1Amount" id="compAcqAgent2PayDate1Amount"
            inputId="currency-us" mode="currency" currency="USD" locale="en-US">
          </p-inputNumber>
          <label for="compAcqAgent2PayDate1Amount">Acq Agent2 Pay Date1 Amt</label>
          @for (validation of validationMessages.compAcqAgent2PayDate1Amount; track validation) {
            <span>
              @if (
                form1.get('compAcqAgent2PayDate1Amount').hasError(validation.type) &&
                (form1.get('compAcqAgent2PayDate1Amount').dirty ||
                form1.get('compAcqAgent2PayDate1Amount').touched)
                ) {
                <small class="p-invalid">{{ validation.message }}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-4">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown class="w-100" [options]="statuses" formControlName="compAcqAgent2PayDate1Status"
          optionLabel="name" optionValue="value" placeholder="Payment Status"></p-dropdown>
          <label for="compAcqAgent2PayDate1Status">Payment Status</label>
          @for (validation of validationMessages.compAcqAgent2PayDate1Status; track validation) {
            <span>
              @if (
                form1.get('compAcqAgent2PayDate1Status').hasError(validation.type) &&
                (form1.get('compAcqAgent2PayDate1Status').dirty ||
                form1.get('compAcqAgent2PayDate1Status').touched)
                ) {
                <small class="p-invalid">{{ validation.message }}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-4">
        <span class="p-float-label w-100 mb-3">
          <p-calendar formControlName="compAcqAgent2PayDate2" inputId="compAcqAgent2PayDate2" appendTo="body">
          </p-calendar>
          <label for="compAcqAgent2PayDate2">Acq Agent2 Pay Date2</label>
          @for (validation of validationMessages.compAcqAgent2PayDate2; track validation) {
            <span>
              @if (
                form1.get('compAcqAgent2PayDate2').hasError(validation.type) &&
                (form1.get('compAcqAgent2PayDate2').dirty ||
                form1.get('compAcqAgent2PayDate2').touched)
                ) {
                <small class="p-invalid">{{ validation.message }}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-4">
        <span class="p-float-label required-field w-100 mb-3">
          <p-inputNumber class="w-100 eap-input" formControlName="compAcqAgent2PayDate2Amount" id="compAcqAgent2PayDate2Amount"
            inputId="currency-us" mode="currency" currency="USD" locale="en-US">
          </p-inputNumber>
          <label for="compAcqAgent2PayDate2Amount">Acq Agent2 Pay Date2 Amt</label>
          @for (validation of validationMessages.compAcqAgent2PayDate2Amount; track validation) {
            <span>
              @if (
                form1.get('compAcqAgent2PayDate2Amount').hasError(validation.type) &&
                (form1.get('compAcqAgent2PayDate2Amount').dirty ||
                form1.get('compAcqAgent2PayDate2Amount').touched)
                ) {
                <small class="p-invalid">{{ validation.message }}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-4">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown class="w-100" [options]="statuses" formControlName="compAcqAgent2PayDate2Status"
          optionLabel="name" optionValue="value" placeholder="Payment Status"></p-dropdown>
          <label for="compAcqAgent2PayDate2Status">Payment Status</label>
          @for (validation of validationMessages.compAcqAgent2PayDate2Status; track validation) {
            <span>
              @if (
                form1.get('compAcqAgent2PayDate2Status').hasError(validation.type) &&
                (form1.get('compAcqAgent2PayDate2Status').dirty ||
                form1.get('compAcqAgent2PayDate2Status').touched)
                ) {
                <small class="p-invalid">{{ validation.message }}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-12 mt-3"><b>Real Estate Agent 1</b></div>
      <div class="col-lg-4">
        <span class="p-float-label required-field w-100 mb-3">
          <p-dropdown [options]="percentageValuesPositive" formControlName="compRetAgent1Pct" (onChange)="updateAmount($event, 'retagent1pct')"
            optionLabel="name" optionValue="value" [filter]="true" filterBy="name" [showClear]="false"
            placeholder="Agent 1 Pct" appendTo="body">
          </p-dropdown>
          <label for="compRetAgent1Pct">Agent 1 Pct</label>
          @for (validation of validationMessages.compRetAgent1Pct; track validation) {
            <span>
              @if (form1.get('compRetAgent1Pct').hasError(validation.type) && (form1.get('compRetAgent1Pct').dirty || form1.get('compRetAgent1Pct').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-4">
        <span class="p-float-label required-field w-100 mb-3">
          <p-dropdown [options]="percentageValuesPositive" formControlName="compRetAgent1SplitPct" (onChange)="updateAmount($event, 'retagent1splitpct')"
            optionLabel="name" optionValue="value" [filter]="true" filterBy="name" [showClear]="false"
            placeholder="Agent 1 Split Pct" appendTo="body">
          </p-dropdown>
          <label for="compRetAgent1SplitPct">Agent 1 Split Pct</label>
          @for (validation of validationMessages.compRetAgent1SplitPct; track validation) {
            <span>
              @if (form1.get('compRetAgent1SplitPct').hasError(validation.type) && (form1.get('compRetAgent1SplitPct').dirty || form1.get('compRetAgent1SplitPct').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-4">
        <span class="p-float-label required-field w-100 mb-3">
          <p-inputNumber class="w-100 eap-input" formControlName="compRetAgent1Amt" id="compRetAgent1Amt"
            inputId="currency-us" mode="currency" currency="USD" locale="en-US">
          </p-inputNumber>
          <label for="compRetAgent1Amt">Agent 1 Amt</label>
          @for (validation of validationMessages.compRetAgent1Amt; track validation) {
            <span>
              @if (
                form1.get('compRetAgent1Amt').hasError(validation.type) &&
                (form1.get('compRetAgent1Amt').dirty ||
                form1.get('compRetAgent1Amt').touched)
                ) {
                <small class="p-invalid">{{ validation.message }}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-12">
        <span class="p-float-label required-field w-100 mb-3">
          <textarea formControlName="compRetAgent1Desc" id="compRetAgent1Desc" [rows]="2"
          pInputTextarea></textarea>
          <label for="compRetAgent1Desc">Agent 1 Desc</label>
          @for (validation of validationMessages.compRetAgent1Desc; track validation) {
            <span>
              @if (
                form1.get('compRetAgent1Desc').hasError(validation.type) &&
                (form1.get('compRetAgent1Desc').dirty ||
                form1.get('compRetAgent1Desc').touched)
                ) {
                <small class="p-invalid">{{ validation.message }}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-12 mt-3"><b>Real Estate Agent 2</b></div>
      <div class="col-lg-4">
        <span class="p-float-label required-field w-100 mb-3">
          <p-dropdown [options]="percentageValuesPositive" formControlName="compRetAgent2Pct" (onChange)="updateAmount($event, 'acqagent2pct')"
            optionLabel="name" optionValue="value" [filter]="true" filterBy="name" [showClear]="false"
            placeholder="Agent 2 Pct" appendTo="body">
          </p-dropdown>
          <label for="compRetAgent2Pct">Agent 2 Pct</label>
          @for (validation of validationMessages.compRetAgent2Pct; track validation) {
            <span>
              @if (form1.get('compRetAgent2Pct').hasError(validation.type) && (form1.get('compRetAgent2Pct').dirty || form1.get('compRetAgent2Pct').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-4">
        <span class="p-float-label required-field w-100 mb-3">
          <p-dropdown [options]="percentageValuesPositive" formControlName="compRetAgent2SplitPct" (onChange)="updateAmount($event, 'acqagent2splitpct')"
            optionLabel="name" optionValue="value" [filter]="true" filterBy="name" [showClear]="false"
            placeholder="Agent 2 Split Pct" appendTo="body">
          </p-dropdown>
          <label for="compRetAgent2SplitPct">Agent 2 Split Pct</label>
          @for (validation of validationMessages.compRetAgent2SplitPct; track validation) {
            <span>
              @if (form1.get('compRetAgent2SplitPct').hasError(validation.type) && (form1.get('compRetAgent2SplitPct').dirty || form1.get('compRetAgent2SplitPct').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-4">
        <span class="p-float-label required-field w-100 mb-3">
          <p-inputNumber class="w-100 eap-input" formControlName="compRetAgent2Amt" id="compRetAgent2Amt"
            inputId="currency-us" mode="currency" currency="USD" locale="en-US">
          </p-inputNumber>
          <label for="compRetAgent2Amt">Agent 2 Amt</label>
          @for (validation of validationMessages.compRetAgent2Amt; track validation) {
            <span>
              @if (
                form1.get('compRetAgent2Amt').hasError(validation.type) &&
                (form1.get('compRetAgent2Amt').dirty ||
                form1.get('compRetAgent2Amt').touched)
                ) {
                <small class="p-invalid">{{ validation.message }}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-12">
        <span class="p-float-label required-field w-100 mb-3">
          <textarea formControlName="compRetAgent2Desc" id="compRetAgent2Desc" [rows]="2"
          pInputTextarea></textarea>
          <label for="compRetAgent2Desc">Agent 2 Desc</label>
          @for (validation of validationMessages.compRetAgent2Desc; track validation) {
            <span>
              @if (
                form1.get('compRetAgent2Desc').hasError(validation.type) &&
                (form1.get('compRetAgent2Desc').dirty ||
                form1.get('compRetAgent2Desc').touched)
                ) {
                <small class="p-invalid">{{ validation.message }}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-12 mt-3"><b>Real Estate Payment</b></div>
      <div class="col-lg-4">
        <span class="p-float-label w-100 mb-3">
          <p-calendar formControlName="compRetAgent1PayDate1" inputId="compRetAgent1PayDate1" appendTo="body">
          </p-calendar>
          <label for="compRetAgent1PayDate1">Ret Agent1 Pay Date1</label>
          @for (validation of validationMessages.compRetAgent1PayDate1; track validation) {
            <span>
              @if (
                form1.get('compRetAgent1PayDate1').hasError(validation.type) &&
                (form1.get('compRetAgent1PayDate1').dirty ||
                form1.get('compRetAgent1PayDate1').touched)
                ) {
                <small class="p-invalid">{{ validation.message }}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-4">
        <span class="p-float-label required-field w-100 mb-3">
          <p-inputNumber class="w-100 eap-input" formControlName="compRetAgent1PayDate1Amount" id="compRetAgent1PayDate1Amount"
            inputId="currency-us" mode="currency" currency="USD" locale="en-US" readonly="true">
          </p-inputNumber>
          <label for="compRetAgent1PayDate1Amount">Ret Agent1 Pay Date1 Amt</label>
          @for (validation of validationMessages.compRetAgent1PayDate1Amount; track validation) {
            <span>
              @if (
                form1.get('compRetAgent1PayDate1Amount').hasError(validation.type) &&
                (form1.get('compRetAgent1PayDate1Amount').dirty ||
                form1.get('compRetAgent1PayDate1Amount').touched)
                ) {
                <small class="p-invalid">{{ validation.message }}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-4">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown class="w-100" [options]="statuses" formControlName="compRetAgent1PayDate1Status"
          optionLabel="name" optionValue="value" placeholder="Payment Status"></p-dropdown>
          <label for="compRetAgent1PayDate1Status">Payment Status</label>
          @for (validation of validationMessages.compRetAgent1PayDate1Status; track validation) {
            <span>
              @if (
                form1.get('compRetAgent1PayDate1Status').hasError(validation.type) &&
                (form1.get('compRetAgent1PayDate1Status').dirty ||
                form1.get('compRetAgent1PayDate1Status').touched)
                ) {
                <small class="p-invalid">{{ validation.message }}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-4">
        <span class="p-float-label w-100 mb-3">
          <p-calendar formControlName="compRetAgent2PayDate1" inputId="compRetAgent2PayDate1" appendTo="body">
          </p-calendar>
          <label for="compRetAgent2PayDate1">Ret Agent2 Pay Date1</label>
          @for (validation of validationMessages.compRetAgent2PayDate1; track validation) {
            <span>
              @if (
                form1.get('compRetAgent2PayDate1').hasError(validation.type) &&
                (form1.get('compRetAgent2PayDate1').dirty ||
                form1.get('compRetAgent2PayDate1').touched)
                ) {
                <small class="p-invalid">{{ validation.message }}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-4">
        <span class="p-float-label required-field w-100 mb-3">
          <p-inputNumber class="w-100 eap-input" formControlName="compRetAgent2PayDate1Amount" id="compRetAgent2PayDate1Amount"
            inputId="currency-us" mode="currency" currency="USD" locale="en-US" readonly="true">
          </p-inputNumber>
          <label for="compRetAgent2PayDate1Amount">Ret Agent2 Pay Date1 Amt</label>
          @for (validation of validationMessages.compRetAgent2PayDate1Amount; track validation) {
            <span>
              @if (
                form1.get('compRetAgent2PayDate1Amount').hasError(validation.type) &&
                (form1.get('compRetAgent2PayDate1Amount').dirty ||
                form1.get('compRetAgent2PayDate1Amount').touched)
                ) {
                <small class="p-invalid">{{ validation.message }}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-4">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown class="w-100" [options]="statuses" formControlName="compRetAgent2PayDate1Status"
          optionLabel="name" optionValue="value" placeholder="Payment Status"></p-dropdown>
          <label for="compRetAgent2PayDate1Status">Payment Status</label>
          @for (validation of validationMessages.compRetAgent2PayDate1Status; track validation) {
            <span>
              @if (
                form1.get('compRetAgent2PayDate1Status').hasError(validation.type) &&
                (form1.get('compRetAgent2PayDate1Status').dirty ||
                form1.get('compRetAgent2PayDate1Status').touched)
                ) {
                <small class="p-invalid">{{ validation.message }}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-12">
        <span class="p-float-label required-field w-100 mb-3">
          <textarea formControlName="opsNote" id="opsNote" [rows]="2" pInputTextarea></textarea>
          <label for="opsNote">Ops Note</label>
          @for (validation of validationMessages.opsNote; track validation) {
            <span>
              @if (
                form1.get('opsNote').hasError(validation.type) &&
                (form1.get('opsNote').dirty ||
                form1.get('opsNote').touched)
                ) {
                <small class="p-invalid">{{ validation.message }}
                </small>
              }
            </span>
          }
        </span>
      </div>
    </div>
  </div>
  <hr />
  <div class="row m-0">
    <div class="col-lg-12">
      <div class="btn-group">
        <div class="button-group">
          @if (employeeAcqPaymentId) {
            <button pButton class="btn-delete p-button-outlined p-button-danger"
            (click)="onFormDelete()">Delete</button>
          }
        </div>

        <div class="button-group">
          <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
          @if (!employeeAcqPaymentId) {
            <button pButton class="btn-addt p-button"
            (click)="formAdd()">Add</button>
          }

          @if (employeeAcqPaymentId) {
            <button pButton class="btn-upt p-button"
            (click)="formUpdate()">Update</button>
          }
        </div>
      </div>
    </div>
  </div>
</div>